import { useState } from "react";
import { Link } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { Badge, Button } from "web-design-system";
import { PortfolioReview } from "creso-core/types";
import { Page } from "@core/components/layout/page";
import { EditColumnsMenu } from "./edit-columns-menu";
import { DEFAULT_VISIBLE_COLUMNS, HoldingColumnKey } from "./holding-columns";
import { HoldingsTable } from "./holdings-table";
import { LiveInsights } from "./live-insights";

export function ReviewWorkbench({ review }: { review: PortfolioReview }) {
  const [visibleColumns, setVisibleColumns] = useState<HoldingColumnKey[]>(
    DEFAULT_VISIBLE_COLUMNS
  );
  const firstName = review.client_name?.split(" ")[0];

  return (
    <Page>
      <Page.Content>
        <Page.Header
          title={
            <div className="flex items-center gap-4">
              <Button variant="outline" size="icon" aria-label="Back" asChild>
                <Link
                  to="/clients/$id/review"
                  params={{ id: String(review.client_id) }}
                >
                  <ArrowLeft />
                </Link>
              </Button>
              <h4 className="whitespace-nowrap">
                {firstName
                  ? `${firstName}’s Portfolio Review`
                  : "Portfolio Review"}
              </h4>
              {review.status === "FINALIZED" ? (
                <Badge
                  variant="custom"
                  className="bg-tag-green font-semibold text-tag-green-foreground"
                >
                  Finalized
                </Badge>
              ) : null}
            </div>
          }
          actions={
            <>
              <Button variant="outline">Generate Review</Button>
              <Button>Export Report</Button>
            </>
          }
        />
        <Page.Body className="grid grid-cols-1 items-start gap-6 lg:grid-cols-[minmax(0,1fr)_30rem]">
          <section className="flex min-w-0 flex-col gap-6">
            <div className="flex items-center justify-between gap-4">
              <h5>Holdings</h5>
              <EditColumnsMenu
                visible={visibleColumns}
                onChange={setVisibleColumns}
              />
            </div>
            <HoldingsTable review={review} visibleColumns={visibleColumns} />
          </section>
          <LiveInsights insights={review.insights} />
        </Page.Body>
      </Page.Content>
    </Page>
  );
}
